import { newAuthService } from '@trp-ta-nitro/auth-browser-js';

import getConfig from '../config';
import {
    NON_GUEST_ENTITLEMENTS,
    RPS_ENTITLEMENT,
    II_ENTITLEMENT
} from '../utils/constants';

const getAuthState = () => {
    const authState = newAuthService({
        apiKey: getConfig('apiKey'),
        types: {
            external: {
                apiKey: getConfig('apiKey'),
                requireAuthentication: false,
                authorizeUrl: `${getConfig('externalDomain')}/v0/ciam-public/me`
            },
            internal: {}
        }
    }).verifyAuthentication();

    return authState;
};

/**
 * @return {Boolean} - indicates if authenticated
 */
export const getLoginStatus = () =>
    getAuthState().then(({ authenticated }) => authenticated);

/**
 * @return {Boolean} - indicates if using a guest account login
 */
export const checkUserAccountType = () =>
    getAuthState()
        .then(({ entitlements }) => {
            const isGuestAccount = !entitlements.some((entitlement) =>
                NON_GUEST_ENTITLEMENTS.includes(entitlement)
            );
            const isRpsUser = entitlements.includes(RPS_ENTITLEMENT);
            const isCrossoverUser =
                entitlements.includes(RPS_ENTITLEMENT) &&
                entitlements.includes(II_ENTITLEMENT);

            return { isGuestAccount, isRpsUser, isCrossoverUser };
        })
        .catch((error) => {
            throw error;
        });
